
export const UPDATE_USERNAME = 'UPDATE_USERNAME'

export const updateUsername = (username) => ({
  type: UPDATE_USERNAME,
  username,
})
